import { render, staticRenderFns } from "./landing-page.vue?vue&type=template&id=65480a82&scoped=true&"
import script from "./landing-page.vue?vue&type=script&lang=js&"
export * from "./landing-page.vue?vue&type=script&lang=js&"
import style0 from "./landing-page.vue?vue&type=style&index=0&id=65480a82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65480a82",
  null
  
)

export default component.exports